// extracted by mini-css-extract-plugin
module.exports = {"signUp":"SignUp_signUp__3RUHg","content":"SignUp_content__3152J","form":"SignUp_form__2ZVtY","error":"SignUp_error__37FWy","button":"SignUp_button__4ucYa"};